import {
	Anchor,
	Box,
	Divider,
	Modal,
	ModalProps,
	Stack,
	Text
} from "@mantine/core"

import XIcon from "@assets/svg/x.svg?react"

import styles from "./AssistanceModal.module.css"
import { eventTrackingItems } from "@utils/eventTracking"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"

export type AssistanceModalContactMethod = {
	label: string
	value: string
}

export function AssistanceModal(props: ModalProps) {
	const { dictionary } = useAEMDictionary()

	const handlePhoneClick = () => {
		eventTrackingItems({
			event_name: "click",
			link_url: `tel:${dictionary?.furtherAssistanceModalPhone}`,
			category: "click",
			interactionType: "assistance_phone_click",
			navLinkText: dictionary?.furtherAssistanceModalPhone
		})
	}

	const handleEmailClick = () => {
		eventTrackingItems({
			event_name: "click",
			link_url: `mailto:${dictionary?.furtherAssistanceModalEmail}`,
			category: "click",
			interactionType: "assistance_email_click",
			navLinkText: dictionary?.furtherAssistanceModalEmail
		})
	}

	return (
		dictionary && (
			<Modal
				{...props}
				centered
				size="lg"
				classNames={{
					header: styles.modalHeader,
					content: styles.modalContent,
					body: styles.modalBody
				}}
				closeButtonProps={{
					"aria-label": "Close Assistance Modal",
					icon: <XIcon viewBox={"6 6 12 12"} width={16} height={16} />
				}}
			>
				<Stack className={styles.container}>
					<Stack className={styles.innerContainer}>
						<Text fz={22} fw={600} lh={1.4} ta="center">
							{dictionary.furtherAssistanceModalTitle}
						</Text>
						<Text
							fz={13}
							fw={400}
							lh={1.5}
							c="var(--text-color-grey)"
							ta="center"
						>
							{dictionary.furtherAssistanceModalBody}
						</Text>
					</Stack>
					<Divider />
					<Stack className={styles.innerContainer}>
						<Text fz={16} fw={600} lh={1.9} ta="center">
							{dictionary.furtherAssistanceModalSubheader}
						</Text>
						<Text
							c="var(--text-color-grey)"
							fz={13}
							fw={400}
							lh={1.6}
							ta="center"
						>
							{dictionary.furtherAssistanceModalSubtext}
						</Text>
						<Box ta="center">
							<Box>
								<Text span c="var(--text-color-grey)" fz={13} fw={400} lh={1.6}>
									{`${dictionary.phone} `}
								</Text>
								<Anchor
									fw={500}
									c="var(--text-color-grey)"
									fz={13}
									lh={1.6}
									href={`tel:${dictionary.furtherAssistanceModalPhone}`}
									onClick={handlePhoneClick}
								>
									{dictionary.furtherAssistanceModalPhone}
								</Anchor>
							</Box>
							<Box>
								<Text span c="var(--text-color-grey)" fz={13} fw={400} lh={1.6}>
									{`${dictionary.email} `}
								</Text>
								<Anchor
									fz={13}
									fw={500}
									href={`mailto:${dictionary.furtherAssistanceModalEmail}`}
									onClick={handleEmailClick}
								>
									{dictionary.furtherAssistanceModalEmail}
								</Anchor>
							</Box>
						</Box>
						<Text c="var(--text-color-grey)" fz={11} fw={400} lh={1.9}>
							{dictionary.furtherAssistanceModalOpenHours}
						</Text>
					</Stack>
				</Stack>
			</Modal>
		)
	)
}
